import { Modal } from '@/components/Modal';
import { KnowYourLimitModal } from '@/components/modals/KnowYourLimit';
import { Modals } from '@/helpers/modals';
import { useGetCommonStore, useModalsStore } from '@/store';

export const useKnowYourLimit = () => {
  const useCommonStore = useGetCommonStore();

  const isKnowYourLimit = useCommonStore.use.isKnowYourLimit();
  const afterRegStep = useCommonStore.use.afterRegStep();
  const open = useModalsStore.use.open();

  const handleLimitModal = () => {
    useCommonStore.setState({ isKnowYourLimit: false });
    afterRegStep && open(Modals.Deposit);
  };

  return isKnowYourLimit ? (
    <Modal>
      <KnowYourLimitModal onClose={handleLimitModal} />
    </Modal>
  ) : null;
};
